import connectSocket from '../connectSocket';
import { PREFIX_OCR } from '../constants';
import disconnectSocket from '../disconnectSocket';

const baseURL = import.meta.env.VITE_WISE_SOCKET_URL;

export const connect = (id) => connectSocket(`${baseURL}/${id}`, PREFIX_OCR);
export const disconnect = () => disconnectSocket(PREFIX_OCR);
